import InspectionDetailsPage from './InspectionDetailsPage';

export default InspectionDetailsPage;
